<template>
    <div v-show="visible">

        <el-dialog title="配置审核人" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading"
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="600px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="200px">
                
                
                <el-form-item  v-for="(indexItem, indexN) in tabData" :key="indexN" :label="indexItem.tabTitle">

                    <el-cascader style="width:350px;"
                            :options="teachers" filterable
                            v-model="form.schoolCheckUsers['user'+indexN]"
                            :props="{ multiple: true }"
                            placeholder="请选择学校审核人"
                            collapse-tags
                            clearable>
                    </el-cascader>

                    <!-- <el-select v-model="form.areaCheckUsers['user'+indexN]" clearable multiple
                        collapse-tags placeholder="请选择学区审核人">
                        <el-option filterable
                            v-for="item in areaUsers"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> -->

                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" v-if="releaseSign !=2 ">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    deptId:"",
                    schoolCheckUsers:{},
                    // areaCheckUsers:{}
                },
                rules: {
                },
                tabData:[],
                teachers:[],
                // areaUsers:[],
                loading:false,
                loadingText:"",
                releaseSign:"",
            }
        },
        components: {
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                this.loading=true;
                this.loadingText="数据在加载中...";

                this.releaseSign=data.releaseSign;
                this.form.deptId=data.deptId;
                this.form.id=data.id;
                this.form.schoolCheckUsers={};
                // this.form.areaCheckUsers={};

                // 获取Tab列表
                this.getTabName();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // getAreaUser(){ // 获取学区审核人
            //     this.areaUsers=[];
            //     let url  = this.teacherAssessAreaUserList2Url;
            //     let data = {deptId:this.form.deptId};
            //     this.apiPost(url,data).then((res) => {
            //         if(res.status==200){
            //             this.areaUsers=res.data;
            //             // 初始老师数据
            //             this.getTeachers();
            //         }else{
            //             this.$commonFn.showTip(res.message,3);
            //         }
            //     },(err)=>{
            //         console.log(err);
            //     });
            // },
            getTeachers(){ // 获取老师信息
                let url  = this.listCascaderUser;
                let data = {
                    deptId:this.form.deptId,
                    personType: 2//人员类型（1-学生，2-教职）
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.teachers = res.data;
                        // 获取选中的值
                        this.getSelectVal();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getTabName(){ // 获取tab名称

                this.tabData=[];
                let url  = this.teacherTemplateAssessIndexTabNameListUrl;
                let data = {
                    deptId:this.form.deptId,
                    teacherTemplateManageId:this.form.id
                };
                this.apiPost(url,data).then((res) => { 
                    if(res.status==200){
                        this.tabData=res.data;             
                        // 初始老师数据
                        this.getTeachers();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getSelectVal(){ // 获取选中的值
                let url  = this.teacherTemplateSetcheckListUrl;
                let data = {
                    deptId:this.form.deptId,
                    teacherTemplateManageId:this.form.id
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                       
                       for(let i=0;i<res.data.length;i++){
                           let v=res.data[i];
                        //    // 学区审核人
                        //    this.form.areaCheckUsers['user'+i]=v.areaCheckUsers.split(',');
                           // 学校审核人
                           this.form.schoolCheckUsers['user'+i]=this.getName(v.schoolCheckUsers, this.teachers);
                       }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            save(){
                
                // 验证tab,每个tab都要设置学校审核人，学区审核人
                for(let i=0;i<this.tabData.length;i++){
                    let tab=this.tabData[i];
                    // 验证学校审核人
                    let schoolUser=this.form.schoolCheckUsers['user'+i];
                    // // 验证学区审核人
                    // let areaUser=this.form.areaCheckUsers['user'+i];

                    if(schoolUser == undefined){
                        this.$commonFn.showTip("【"+tab.tabTitle+"】学校审核人未配置",3);
                        return;
                    }

                    // if(areaUser.length == 0){
                    //     this.$commonFn.showTip("【"+tab.tabTitle+"】学区审核人未配置",3);
                    //     return;

                    // }
                }

                let url= this.teacherTemplateSetcheckSaveUrl;
                let data = {
                    teacherTemplateManageId:this.form.id,
                    deptId:this.form.deptId,
                    schoolCheckUsers:JSON.stringify(this.form.schoolCheckUsers),
                    // areaCheckUsers:JSON.stringify(this.form.areaCheckUsers)
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.visible=false;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                }); 
            },
            getName(setVal,data){ // 选中学校审核人
                var arr = new Array();
                // 递归获取层级名称
                if(this.$util.isNotEmpty(data)){
                   let valArr = setVal.split(",");
                   for(var i = 0;i < valArr.length;i++){
                       var tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                }
                return arr;
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                // 递归获取值
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/SetCheckUser.vue